import React, { useState } from "react";
import PromoBanner from '../Components/PromoBanner';
import Navbar from '../Components/Navbar';
import Footer from '../Components/Footer';
import { pushDataLayerEvent } from '../utils/tracking';

const FreeQuote = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    contactNumber: "",
    subject: "",
    message: "",
  });

  const [formErrors, setFormErrors] = useState({});
  const [showPopup, setShowPopup] = useState(false); // Popup state
  const [popupMessage, setPopupMessage] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };
 const handleSubmit = async (e) => {
    e.preventDefault();
    const errors = {};
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // Email validation regex
  
    // Validate inputs
    if (!formData.name) errors.name = "Name is required";
    if (!formData.email) {
      errors.email = "Email is required";
    } else if (!emailRegex.test(formData.email)) {
      errors.email = "Please enter a valid email address";
    }
    if (!formData.contactNumber) errors.contactNumber = "Contact number is required";
    if (!formData.subject) errors.subject = "Subject is required";
    if (!formData.message) errors.message = "Message is required";
  
    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);
    } else {
      try {
        const response = await fetch("https://backend.printtrio.co.uk/api/pages/free-quote", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            name: formData.name,
            email: formData.email,
            contact_number: formData.contactNumber, // Adjusted key name for contactNumber
            subject: formData.subject,
            message: formData.message,
          }),
        });
  
        const data = await response.json();
  
        if (response.ok && data.success) {
          pushDataLayerEvent({
            event: 'generate_lead',
            form_name: 'free_quote_form',
            form_location: '/FreeQuote',
            value: 0,
            currency: 'GBP',
          });
          setPopupMessage("Thank you for requesting a free quote! We will get back to you shortly.");
          setShowPopup(true);
          setFormData({
            name: "",
            email: "",
            contactNumber: "",
            subject: "",
            message: "",
          });
          setFormErrors({});
        } else {
          setPopupMessage("Something went wrong. Please try again.");
          setShowPopup(true);
          console.error("API Error:", data.errors);
        }
      } catch (error) {
        setPopupMessage("An error occurred. Please try again.");
        setShowPopup(true);
        console.error("Error:", error);
      }
    }
  };
  
  

  return (
    <>
   <PromoBanner />
   <Navbar />
    <div className="max-w-4xl mx-auto p-6 bg-gray-50 mt-20 mb-20">
      <div className="text-center mb-8">
        <p className="text-lg mb-2">Email us on: <a href="mailto:info@printtrio.co.uk" className="text-blue-600 hover:underline">info@printtrio.co.uk</a></p>
        <p className="text-lg mb-4">Call us on: <a href="tel:+442033434422" className="text-blue-600 hover:underline">+44 20-33-43-44-22</a></p>
        <p className="text-lg"> Or fill out the form below, and we will provide you with a personalized quote shortly.</p>
      </div>

      <form onSubmit={handleSubmit} className="bg-white shadow-md rounded-lg p-8">
        {/* Name Field */}
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700 mb-1">Your Name</label>
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            className={`w-full p-2 border rounded ${
              formErrors.name ? "border-red-500" : "border-gray-300"
            }`}
            placeholder="Your Name"
          />
          {formErrors.name && <p className="text-red-500 text-sm">{formErrors.name}</p>}
        </div>

        {/* Email Field */}
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700 mb-1">Your Email</label>
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            className={`w-full p-2 border rounded ${
              formErrors.email ? "border-red-500" : "border-gray-300"
            }`}
            placeholder="Your Email"
          />
          {formErrors.email && <p className="text-red-500 text-sm">{formErrors.email}</p>}
        </div>

        {/* Contact Number Field */}
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700 mb-1">Your Contact Number</label>
          <input
            type="text"
            name="contactNumber"
            value={formData.contactNumber}
            onChange={handleChange}
            className={`w-full p-2 border rounded ${
              formErrors.contactNumber ? "border-red-500" : "border-gray-300"
            }`}
            placeholder="Your Contact Number"
          />
          {formErrors.contactNumber && <p className="text-red-500 text-sm">{formErrors.contactNumber}</p>}
        </div>

        {/* Subject Field */}
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700 mb-1">Subject</label>
          <input
            type="text"
            name="subject"
            value={formData.subject}
            onChange={handleChange}
            className={`w-full p-2 border rounded ${
              formErrors.subject ? "border-red-500" : "border-gray-300"
            }`}
            placeholder="Subject"
          />
          {formErrors.subject && <p className="text-red-500 text-sm">{formErrors.subject}</p>}
        </div>

        {/* Message Field */}
        <div className="mb-6">
          <label className="block text-sm font-medium text-gray-700 mb-1">Your Message</label>
          <textarea
            name="message"
            value={formData.message}
            onChange={handleChange}
            className={`w-full p-2 border rounded ${
              formErrors.message ? "border-red-500" : "border-gray-300"
            }`}
            placeholder="Your Message"
            rows="5"
          />
          {formErrors.message && <p className="text-red-500 text-sm">{formErrors.message}</p>}
        </div>

        {/* Submit Button */}
        <div className="text-center">
          <button
            type="submit"
            className="px-6 py-2 bg-pink-500 text-white font-semibold rounded hover:bg-pink-600"
          >
            Send
          </button>
        </div>
      </form>
    </div>
    <Footer />

    {showPopup && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div 
            className="bg-white p-6 rounded-lg shadow-lg text-center"
            style={{ width: '400px' }}
          >
            <h2 className="text-2xl font-bold text-gray-800 mb-4">
              {popupMessage.includes('Thank you') ? 'Success!' : 'Error'}
            </h2>
            <p className="text-gray-600 mb-6">{popupMessage}</p>
            <button
              onClick={() => setShowPopup(false)}
              className="bg-pink-500 text-white px-6 py-2 rounded-full hover:bg-pink-600"
            >
              OK
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default FreeQuote;
